import 'fslightbox';

function init() {
  refreshFsLightbox();
}

window.addEventListener('load', init, false);
